<template>
  <div>
    <common-table :limitHeight="true" :url="url" :table-columns="tableColumns" :permission="permission"
      :searchs="searchs" :form-fields="formFields" :operate="operate" ref="table" />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "wechatNotifyLog",
  components: { CommonTable },
  data() {
    return {
      operate: [],
      searchs: [
        {
          name: "ruleId",
          placeholder: "规则Id",
          type: "input",
        },
        {
          name: "openId",
          placeholder: "用户Id",
          type: "input",
        },
        {
          name: "agentId",
          placeholder: "网站",
          type: "select",
          selectUrl: "/agent/getAll",
          selectData: [],
        },
      ],
      permission: {
        add: "wechatNotifyLog:add",
        update: "wechatNotifyLog:update",
        delete: "wechatNotifyLog:delete",
        deleteBatch: "wechatNotifyLog:deleteBatch",
      },
      url: {
        get: "/wechatNotifyLog/listByCondition",
        add: "/wechatNotifyLog/add",
        update: "/wechatNotifyLog/update",
        delete: "/wechatNotifyLog/delete/",
        delete_batch: "/wechatNotifyLog/deleteBatch",
      },
      tableColumns: [
        {
          field: "id",
          label: "ID",
          show: false,
          width: "75",
          detail: true,
        },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          width: '100',
        },
        {
          field: "openId",
          label: "用户",
          show: false,
          detail: true,
          width: "",
        },
        {
          field: "ruleId",
          label: "规则ID",
          show: true,
          detail: true,
          width: "75",

        },
        {
          field: "ruleName",
          label: "规则名称",
          show: true,
          detail: true,
          width: "",

        },
        {
          field: "content",
          label: "推送内容",
          show: false,
          detail: true,
          width: "",
        },
        {
          field: 'status',
          label: '发送状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '成功',
              type: 'primary',
            }, {
              key: 1,
              value: '失败',
              type: 'danger'
            },]
          },
        },
        {
          field: "remark",
          label: "备注",
          show: true,
          detail: true,
          width: "",
        }, {
          field: "createTime",
          label: "创建时间",
          show: true,
          detail: true,
          width: "",
        },
      ],
      formFields: {
        addTitle: "推送日志",
        updateTitle: "推送日志",
        model: [
          {
            field: "agentId",
            label: "代理：",
            type: "select",
            placeholder: "请选择代理",
            rules: [{ required: true, message: "请选择代理", trigger: "blur" }],
            selectUrl: "/agent/getAll",
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: "ruleId",
            label: "规则ID",
            type: "input",
            placeholder: "规则ID",
            rules: [{ required: true, message: "请输入规则ID", trigger: "blur" }],
            add: true,
            update: true,
          },
          {
            field: "openId",
            label: "用户ID",
            type: "input",
            placeholder: "用户ID",
            rules: [{ required: true, message: "请输入用户ID", trigger: "blur" }],
            add: true,
            update: true,
          },
          {
            field: "content",
            label: "推送内容",
            type: "textarea",
            placeholder: "请输入推送内容",
            rules: [{ required: true, message: "请输入推送内容", trigger: "blur" }],
            add: true,
            update: true,
          },
          {
            field: "remark",
            label: "备注",
            type: "input",
            placeholder: "请输入备注",
            rules: [],
            add: true,
            update: true,
          },
        ],
      },
    };
  },
};
</script>

<style scoped></style>
